import { render } from "./PasswordLoginPanel.vue?vue&type=template&id=6ca520f9"
import script from "./PasswordLoginPanel.vue?vue&type=script&lang=js"
export * from "./PasswordLoginPanel.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__